import "../../css/fonts.css";
import "../../css/container.css";
import "../../css/misc.css";
import "../../css/subpages.css";

import { useIsMobile } from "../../hooks/is.mobile";
import { ImportAll, shuffleArray } from "../../utils/utils";
import { ClickableImageGrid } from "../../components/image.grid";
import { Clickable } from "../../components/clickable.container";
import { useNavigate } from "react-router-dom";
import backIcon from "../../assets/back.png";

const imported = ImportAll(
  require.context("../../assets/3dAssets", false, /\.(png|jpe?g|svg)$/),
);
const images = shuffleArray(imported);

export const Assets3D: React.FC<any> = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  return (
    <div>
      <div>
        {isMobile ? (
          <Clickable
            backgroundUrl={backIcon}
            onclick={() => {
              navigate("/services");
            }}
            style="back"
          />
        ) : (
          ""
        )}
        <div className={"title-text-font" + " " + "text-align" + " " + "title"}>
          Form Meets Function
        </div>
      </div>
      <div
        style={{
          paddingLeft: isMobile ? "10vw" : "4.5vw",
          paddingRight: isMobile ? "10vw" : "4.5vw",
          paddingTop: isMobile ? "6vw" : "2.5vw",
          paddingBottom: isMobile ? "6vw" : "2vw",
          fontSize: isMobile ? "3vw" : "1.5vw",
        }}
      >
        <p>
          Our Assets & Tools collection is built for flexibility. Whether you're
          prototyping, building worlds, or experimenting with new ideas. From 3D
          assets and game systems to development tools, everything we create is
          designed to support creativity across game development, animation, and
          design.
        </p>
        <p>
          Not every asset is game-ready out of the box, but each one is
          thoughtfully made and ready to be adapted to fit your pipeline.
        </p>
      </div>
      <div style={{ paddingTop: "2vw" }}>
        <ClickableImageGrid images={images} clickable={true} />
      </div>
      <div
        className={
          "title-text-font" + " " + "text-align" + " " + "optional-text"
        }
      >
        Looking for something custom? Get in touch, and let’s build something
        great together.
      </div>
    </div>
  );
};
